import playAudio from "../lib/play-audio"

function ProverbDisplay({ children: proverb }: { children: Proverb }) {
    return <div style={{ marginTop: "1rem", marginBottom: "2rem" }}>
        <div onClick={() => playAudio(proverb.num)} style={{ marginBottom: "1rem" }}>
            <div style={{ marginBottom: "0.25rem" }}>
                <div style={{ marginBottom: "0.25rem", fontSize: "22px" }}>{proverb.p1}</div>
                {proverb.p2 && <div style={{ marginBottom: "0.25rem", fontSize: "22px" }}>{proverb.p2}</div>}
            </div>
            <div style={{ marginTop: "0.5rem" }}>
                <div style={{ marginBottom: "0.25rem" }}>{proverb.e1}</div>
                {proverb.e2 && <div style={{ marginBottom: "0.25rem", marginTop: "0.25rem" }}>{proverb.e2}</div>}
            </div>
        </div>
        <details>
            <summary style={{ color: "grey", fontSize: "small" }}>meaning:</summary>
            <p style={{ lineHeight: "1.4" }}>{proverb.interp}</p>
        </details>
    </div>;
}

export default ProverbDisplay;